<template>
    <p class="mb-4 text-sm text-gray-400">
        <slot />
    </p>
</template>
